import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f371198"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-[80px] relative yg-wrap" }
const _hoisted_2 = { class: "content-wrap w-[100%]" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "员工风采", -1))
const _hoisted_5 = { class: "desc mt-[20px] mb-[30px] px-[32px]" }
const _hoisted_6 = {
  key: 1,
  class: "h-[400px] w-[100%]"
}

import { nextTick, reactive, ref, toRefs } from "vue";
import "swiper/css/pagination"; // 轮播图底面的小圆点
import "swiper/css/navigation"; // 轮播图两边的左右箭头
import TitleComp from "../HomeComp/titleComp.vue";
import { Autoplay, Navigation, Scrollbar } from "swiper";
import { getConfig } from "@/http/api/index";
import useNavigation from "@/hooks/useNavigation";
import useGetDevice from "@/hooks/useGetDevice";
interface IList {
  logo: string;
  title: string;
  remark: string;
  skin: string | unknown;
  articleId: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'swiperComp',
  setup(__props) {

const { push } = useNavigation();
const navigation = ref({
  nextEl: ".swiper-button-next",
  prevEl: ".swiper-button-prev",
});
// 在modules加入要使用的模块
const modules = [Autoplay, Navigation, Scrollbar];
const prevEl = (item, index) => {
  console.log("上一张" + index + item);
};

const {
  versions: { isMobile },
} = useGetDevice();
const swiperConfig = reactive({
  centeredSlides: !isMobile,
  slidesPerView: isMobile ? 1 : 5,
  watchSlidesProgress: !isMobile,
});
const { centeredSlides, slidesPerView, watchSlidesProgress } =
  toRefs(swiperConfig);

const nextEl = () => {
  // console.log('下一张')
};
// 更改当前活动swiper
let changeTimer: any = null;
// 更改当前活动swiper
const onSlideChange = (swiper) => {
  if (isMobile) return;
  // swiper是当前轮播的对象，里面可以获取到当前swiper的所有信息，当前索引是activeIndex
  changeTimer && clearTimeout(changeTimer);
  changeTimer = setTimeout(() => {
    nextTick(() => {
      const slides = swiper.slides;
      for (let i = 0; i < slides.length; i++) {
        const slide = slides.eq(i);
        slide[0].classList.remove("swiper-slide-prev-border");
        if (slide[0].classList.contains("swiper-slide-prev")) {
          slide[0].previousSibling.classList.add("swiper-slide-prev-border");
        }
      }
    });
  }, 50);
};

function setTransition(swiper, transition) {
  if (isMobile) return;
  for (let i = 0; i < swiper.slides.length; i++) {
    let slide = swiper.slides.eq(i);
    slide.transition(transition);
  }
}
function setTranslate(swiper) {
  if (isMobile) return;
  const slides = swiper.slides;
  for (let i = 0; i < slides.length; i++) {
    const slide = slides.eq(i);
    const progress = slides[i].progress;
    slide[0].children[0].setAttribute(
      "style",
      `transform: scale(${1 - Math.abs(progress) / 8})`
    );
  }
}
function goNewsDetail(item: IList) {
  push({
    path: "/news/detail",
    query: {
      id: item.articleId,
    },
  });
}
const list = ref<Array<IList>>([]);
function getSliderList() {
  getConfig().then((res: any) => {
    list.value = res.data as any;
  });
}
getSliderList();

return (_ctx: any,_cache: any) => {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TitleComp, { title: "员工风采" }),
    (list.value.length)
      ? (_openBlock(), _createBlock(_component_swiper, {
          key: 0,
          modules: modules,
          "slides-per-view": _unref(slidesPerView),
          centeredSlides: _unref(centeredSlides),
          loop: true,
          autoplay: "",
          style: _normalizeStyle({ height: _unref(isMobile) ? 'auto' : '400px' }),
          watchSlidesProgress: _unref(watchSlidesProgress),
          onSetTranslate: setTranslate,
          onSetTransition: setTransition,
          navigation: navigation.value,
          scrollbar: { draggable: false },
          class: "swiperBox",
          onSlideChange: onSlideChange
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
              return (_openBlock(), _createBlock(_component_swiper_slide, {
                key: item,
                onClick: ($event: any) => (goNewsDetail(item)),
                class: "cursor-pointer"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("img", {
                      class: "w-[100%]",
                      src: item.logo
                    }, null, 8, _hoisted_3),
                    _createElementVNode("div", {
                      class: _normalizeClass(["swiper-container-text", { 'is-mobile': _unref(isMobile) }])
                    }, [
                      _hoisted_4,
                      _createElementVNode("p", _hoisted_5, _toDisplayString(item.remark), 1)
                    ], 2)
                  ])
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["slides-per-view", "centeredSlides", "style", "watchSlidesProgress", "navigation"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6)),
    _createElementVNode("div", {
      class: "swiper-button-prev",
      onClik: _withModifiers(prevEl, ["stop"])
    }, null, 32),
    _createElementVNode("div", {
      class: "swiper-button-next",
      onClik: _withModifiers(nextEl, ["stop"])
    }, null, 32)
  ]))
}
}

})